<template>
  <div v-if="nextSession && nextSessionDateTimeMS > 0" :class="getNotifierClasses">
    <div v-if="!bookingOrViewing || topBarView" class="upcoming" :class="topBarView ? 'upcoming--topBarView' : ''">
      {{ notifierHeaderText }}
    </div>
    <MoreThanTenToSession
      v-if="STATE === states.NULL"
      :class="topBarView ? 'minifiedNotifier--topBarView-message' : ''"
      :minutesToNextSession="minutesToNextSession"
      :sessionIsMatched="sessionIsMatched"
    />
    <TimerTenToStartMessage
      v-if="STATE === states.LESS_THAN_TEN || STATE === states.LESS_THAN_ONE"
      :class="topBarView ? 'minifiedNotifier--topBarView-message' : ''"
      :timeLeft="getTimeToSessionStart"
      :sessionIsMatched="sessionIsMatched"
    />
    <TimerOngoingMessage
      v-else-if="STATE >= states.STARTED && STATE < states.SESSION_END"
      :class="topBarView ? 'minifiedNotifier--topBarView-message' : ''"
      :hasJoinedDuringSession="hasJoinedDuringSession"
      :timeLeft="getTimeToSessionEnd"
      :sessionIsMatched="sessionIsMatched"
      :isLate="isLate"
    />
    <TimerFinishedMessage v-else-if="STATE >= states.SESSION_END" :class="topBarView ? 'minifiedNotifier--topBarView-message' : ''" />
    <TimerSessionSnippet
      :sessionIsMatched="sessionIsMatched"
      :showJoinLink="STATE > states.NULL"
      :nextSession="nextSession"
      :userID="userID"
      :prefers24Hours="prefers24Hours"
      :bookingOrViewing="bookingOrViewing"
      :notifierHeaderText="notifierHeaderText"
      :topBarView="topBarView"
      :shrinkedView="shrinkedView"
    />
    <div v-if="!shrinkedView && !bookingOrViewing && !topBarView" @click="openGuidelines" class="review-guidelines review-custom">ℹ Review session guidelines</div>
  </div>
</template>

<script>
import Timer from "./Timer";

import MoreThanTenToSession from "./TimerMessages/MoreThanTenToSession";
import TimerTenToStartMessage from "./TimerMessages/TimerTenToStartMessage";
import TimerOngoingMessage from "./TimerMessages/TimerOngoingMessage";
import TimerFinishedMessage from "./TimerMessages/TimerFinishedMessage";
import TimerSessionSnippet from "./TimerSessionSnippet";

import { SESSION_LENGTH_MS } from "../../constants_calendar";

const ONE_MIN = 60 * 1000;

export default {
  name: "CalendarTimer",
  mixins: [Timer],

  props: {
    bookingOrViewing: Boolean,
    topBarView: Boolean,
    shrinkedView: Boolean,
  },

  components: {
    MoreThanTenToSession,
    TimerTenToStartMessage,
    TimerOngoingMessage,
    TimerFinishedMessage,
    TimerSessionSnippet,
  },

  computed: {
    getTimeToSessionStart() {
      const diff = this.nextSessionDateTimeMS - this.time_seconds;
      if (diff < 0) return null;
      return new Date(diff).toISOString().substr(14, 5);
    },
    getTimeToSessionEnd() {
      const diff = this.nextSessionDateTimeMS + SESSION_LENGTH_MS - this.time_seconds;
      if (diff < 0) return null;
      return new Date(diff).toISOString().substr(14, 5);
    },
    isLate() {
      return this.time_seconds > this.nextSessionDateTimeMS + 2 * ONE_MIN;
    },
    sessionIsMatched() {
      return !!(this.nextSession && this.nextSession.partner);
    },
    getNotifierClasses() {
      let notifier = "";
      if (this.bookingOrViewing && !this.shrinkedView) {
        notifier = "minifiedNotifier";
      } else if (this.shrinkedView) {
        notifier = "minifiedNotifier minifiedNotifier--shrinked";
      } else {
        notifier = "notifier";
      }
  
      return notifier;
    },
    notifierHeaderText() {
      let text = "Upcoming";
      const state = this.STATE;
      const states = this.states;
      const isOngoing = state >= states.STARTED && state < states.SESSION_END;
      const isFinished = state >= states.SESSION_END;
      if (isOngoing && !isFinished) {
        text = "Current session";
        if (this.topBarView) {
          text = "Current";
        }
      } else if (isFinished) {
        text = "";
      }
      return text;
    },
  },
  methods: {
    openGuidelines() {
      this.$store.dispatch("modals/setModalState", {
        modal: "miniGuidelines",
        newState: true,
      });
    },
  },
};
</script>

<style scoped>
.review-guidelines {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  font-size: 16px;
  border-radius: 360px;
  background-color: #ffffff;
  margin-top: 8px;
  font-weight: 600 !important;
  box-shadow: rgb(15 15 15 / 10%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 2px 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.review-custom {
  border: 1px solid #ffffff;
  padding: 4px;
  box-shadow: unset;
  text-decoration: underline;
  border-radius: unset;
  text-underline-offset: 4px;
  text-decoration-color: #424242;
  background-color: transparent;
  border-color: transparent;
}
.review-guidelines:hover {
  color: #666;
  text-decoration-color: #777;
}
</style>
